// @flow

import React from 'react';

import Page from '../components/Page';
import Section from '../components/Section';

const Support = () => (
  <Page title="Support">
    <Section>
      <h3>Get Support</h3>
      <p>
        <strong>Mailing address</strong><br/>
        Baart Industrial Group<br/>
        PO Box 16528<br/>
        Boise, ID 83715-6528
      </p>
      <p>
        <strong>Warehouse address</strong><br/>
        Baart Industrial Group<br/>
        4660 Pine Timbers Street<br/>
        Suite 165<br/>
        Houston, TX 77041
      </p>
      <p>
        <strong>Toll free phone</strong><br/>
        <a href="tel:1-844-462-2278">(844) GO BAART</a> or <a href="tel:1-844-462-2278">(844) 462-2278</a><br/>
      </p>
      <p>
        <strong>Toll free fax</strong><br/>
        <a href="tel:1-844-317-2178">(844) 317-2178</a>
      </p>
      <p><strong>Baart Tools Version:</strong> {process.env.REACT_APP_VERSION}</p>
    </Section>
  </Page>
);

export default Support;



// WEBPACK FOOTER //
// ./src/views/Support.js